import StepCard from "./StepCard"
import { useT } from "@/i18n"
import { cn } from "@/ui/lib/utils"

// Order matches the issue #87 "details staircase": current team → how each
// person works → how the team fits → the high-stakes decisions.
const STEPS = ["people", "works", "fits", "decisions"] as const

/**
 * PromptJuggler staggers feature cards left/right along a hand-drawn meander.
 * The tidy/serious version keeps that descending, alternating rhythm but
 * makes it symmetric and restrained: cards at 80% width alternate sides of a
 * single faint vertical line. On mobile they stack full-width (no line).
 */
export default function Staircase() {
  const { t } = useT("content")

  return (
    <section className="mx-auto max-w-3xl px-6 py-8 sm:py-12">
      <div className="relative flex flex-col gap-6 sm:gap-10">
        <div
          aria-hidden
          className="absolute inset-y-2 left-1/2 hidden w-px -translate-x-1/2 bg-border sm:block"
        />
        {STEPS.map((key, i) => (
          <div
            key={key}
            className={cn(
              "relative sm:w-4/5",
              i % 2 === 0 ? "sm:self-start" : "sm:self-end",
            )}
          >
            <StepCard
              index={i + 1}
              title={t(`home.steps.${key}.title`)}
              body={t(`home.steps.${key}.body`)}
            />
          </div>
        ))}
      </div>
    </section>
  )
}
